(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["kins-membership-benefits-journey"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-kins-open-benefit]');
    if (trigger) {
      const root = trigger.closest('[data-kins-benefits-journey]');
      const dialog = root.querySelector('.kins-benefits-journey__dialog');
      const image = dialog.querySelector('.kins-benefits-journey__full-image');
      image.src = trigger.dataset.kinsBenefitSrc;
      image.alt = trigger.dataset.kinsBenefitAlt;
      dialog.querySelector('.kins-benefits-journey__full-link').href = image.src;
      dialog.showModal();
    }
    const close = event.target.closest('[data-kins-close-benefit]');
    if (close) close.closest('dialog').close();
  });

  } catch(e) { console.error(e); }
})();
})();
